module.exports = __webpack_public_path__ + "media/images/course_specific_role-2211d39af29c88e2783b68105d401b11.png";